<template>
  <div class="app-body-1160px transparent" v-if="classDataList !== undefined">
    <!-- 标题 -->
    <ModuleHeader title="最新课程" detail="为每一个blender初学者定制的100%免费教学" url="/search"></ModuleHeader>
    <!-- 主体 -->
    <div id="app-open-curriculum-body">
      <!-- 图片 -->
      <a href="https://www.blendermagic.cn/#/curriculum/34b2bb7c-1c7f-11eb-8436-0242ac110002" target="_blank"
         rel="noopener noreferrer">
        <img id="app-open-curriculum-img" alt="pic" src="https://img.blendermagic.cn/new/curriculum/home.jpg"/>
      </a>
      <!-- 主体 -->
      <div id="app-open-curriculum-card-body">
        <ul>
          <li style="float: left" v-for="item in classDataList" :key="item.id">
            <ClassCard :class-info="item"></ClassCard>
          </li>
        </ul>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>

<script>

import ModuleHeader from "@/views/share/home/ModuleHeader";
import AxiosBase from "@/components/axiosBase";
import ClassCard from "@/views/share/ClassCard";

export default {
  name: "NewCurriculum",
  components: {
    ClassCard,
    ModuleHeader
  },
  data() {
    return {
      classDataList: undefined
    }
  },
  beforeMount() {
    AxiosBase.axiosGet("/curriculum/class-limit", {
      params: {
        type:"new",
        limit: 6
      }
    }).then(response => {
      if (response !== 0) {
        this.classDataList = response.data
      }
    })
  },
}
</script>

<style scoped>

#app-open-curriculum-body {
  position: relative;
  text-align: left;
  padding-bottom: 25px;
  height: 600px;
}

#app-open-curriculum-img {
  left: 0;
  top: 0;
  width: 310px;
  height: 589px;
}

#app-open-curriculum-card-body {
  position: absolute;
  left: 310px;
  right: 0;
  top: 0;
  bottom: 0;
  /*background: #ff8a00;*/
}

</style>